import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface ExpandableTextProps {
  text: string;
  maxLength?: number;
  className?: string;
  showButton?: boolean;
  buttonText?: {
    expand: string;
    collapse: string;
  };
}

export const ExpandableText: React.FC<ExpandableTextProps> = ({
  text,
  maxLength = 100,
  className = '',
  showButton = true,
  buttonText = {
    expand: 'View more',
    collapse: 'View less'
  }
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // If text is shorter than maxLength, don't show expand/collapse
  if (text.length <= maxLength) {
    return (
      <p className={`break-words ${className}`}>
        {text}
      </p>
    );
  }

  const displayText = isExpanded ? text : `${text.slice(0, maxLength)}...`;
  const shouldShowButton = showButton && text.length > maxLength;

  return (
    <div className={className}>
      <p className="break-words">
        {displayText}
        {shouldShowButton && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="ml-1 text-sossiety-red-500 hover:text-sossiety-red-400 font-medium text-sm transition-colors duration-200 inline-flex items-center gap-1"
            type="button"
          >
            {isExpanded ? (
              <>
                {buttonText.collapse}
                <ChevronUp className="w-3 h-3" />
              </>
            ) : (
              <>
                {buttonText.expand}
                <ChevronDown className="w-3 h-3" />
              </>
            )}
          </button>
        )}
      </p>
    </div>
  );
};


